<template>
  <div v-if="isLogin" id="app">
    <router-view />
    <div v-if="!isOffline">
      <el-dialog :visible.sync="showBindWx" v-if="!isOffline" class="showBindWxDialog">
        <div style="text-align: center" class="qccontent">
          <h2 style="margin-top: 0px">获取微信项目进度提醒</h2>
          <p style="margin-bottom: 50px">
            请进行以下操作以获取项目进度提醒，提醒将在每日10：00以微信消息形式推送，并支持对项目进行打分和反馈。
          </p>
          <div style="width: 180px; height: 180px; margin: auto">
            <div ref="qrcode" id="qrcode"></div>
          </div>
          <p style="margin-top: 15px; margin-bottom: 0px">使用微信扫描此二维码</p>
          <p style="margin-top: 0px">将龙猫ID与您的微信绑定</p>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="showBindConcernWx" v-if="!isOffline" class="showBindWxDialog">
        <div style="text-align: center" class="qccontent">
          <h2 style="margin-top: 0px">获取微信项目进度提醒</h2>
          <p>
            请使用当前绑定的微信号(<span
            style="font-size: 22px; font-weight: 800"
          >{{ this.wxNick }}</span
          >)扫描下方二维码或直接搜索关注“龙猫数据客户服务”公众号，即可每天早10：00收取最新项目进度提醒，并可对项目进行反馈。
          </p>
          <img
            style="width: 180px; height: 180px; margin: auto"
            src="/static/customer_service.png"
          />

          <div class="qc-line"></div>

          <p style="color: #5e6678">
            如需更换绑定的微信号，使用新微信号扫描下方二维码换绑即可
          </p>
          <div style="width: 180px; height: 180px; margin: auto">
            <div id="qrcodeConcern"></div>
          </div>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { getuserInfo, getState, getStatus } from "@/utils/info.js";
import { longmao } from "@/utils/sso.js";
import { isOffline } from '@/utils/common'
import QRCode from "qrcodejs2";
export default {
  name: "App",
  data() {
    return {
      isLogin: false,
      showBindWx: false,
      changeWxToken: "",
      wxNick: "",
      showTimer: true,
      showBindConcernWx: false,
      isOffline: isOffline(),
    };
  },
  beforeMount() {
    /*if(window.location.pathname == '/') {
      document.getElementById('loading').style.display="none"
      this.isLogin = true
      return;
    }*/
    if (longmao.sso.getToken() == null) {
      return;
    }

    longmao.sso
      .check()
      .then(() => {
        document.getElementById("loading").style.display = "none";
        getuserInfo(localStorage.getItem("token")).then((data) => {
          this.$store.commit("changeUser", data);
          if (data.wx_bind == 0) {
              this.handleGetState()
          } else if (data.member_wx_bind == 0) {
            this.handleGetStateMember(data)
          } else {
            this.showTimer = false;
          }
        });
        this.isLogin = true;
        if (window.location.pathname == "/") {
          this.$router.push({ path: "data_notes/program_table" });
        }
      })
      .catch((error) => {
        if (error && error.code == "401") {
          this.$message({
            message: error.message,
            duration: 1500,
            type: "error",
          });
          longmao.sso.login();
        } else {
          let message = error.message || "登录服务异常";
          this.$message({
            message: message,
            duration: 1500,
            type: "error",
          });
        }
      });
  },
  mounted() {
    const timer = setInterval(() => {
      if (!this.showTimer) {
        clearInterval(timer);
        return false;
      }
      if (!this.showBindWx && !this.showBindConcernWx) {
        return false;
      }
      getStatus(localStorage.getItem("token"), this.changeWxToken).then(
        (data) => {
          if (data.code == 200) {
            if(this.showBindWx){
              this.showBindWx = false;
              this.$message({
                message: "绑定成功，请关注公众号",
                duration: 1500,
                type: "success"
              });
            }
            if(this.showBindConcernWx){
              this.showBindConcernWx = false;
              this.$message({
                message: "换绑成功",
                duration: 1500,
                type: "success"
              });
            }
            getuserInfo(localStorage.getItem("token")).then((data) => {
              this.$store.commit("changeUser", data);
              if (data.wx_bind == 0) {
                  this.handleGetState()
                } else if (data.member_wx_bind == 0) {
                  this.handleGetStateMember(data)
                } else {
                  this.showTimer = false;
                }
              });
          } else if (data.code == 201) {
          } else {
            this.showBindWx = false;
            this.showBindConcernWx = false;
            clearInterval(timer);
            this.$message({
              message: data.message,
              duration: 1500,
              type: "error",
            });
          }
        }
      );
    }, 2000);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
  },
  methods: {
    handleGetState: function () {
      //展示绑定微信二位码
     getState(localStorage.getItem("token")).then((data) => {
        this.showBindWx = true;
        this.showTimer = true;
        this.$nextTick(() => {
          // new QRCode(document.getElementById("qrcode"), data.url);
          document.getElementById("qrcode").innerHTML = "";
          this.changeWxToken = data.state;
          const qrcode = new QRCode("qrcode", {
            width: 180,
            height: 180,
            text: data.url, // 二维码地址
            colorDark: "#000",
            colorLight: "#fff",
          });
          qrcode.clear();
          qrcode.makeCode(data.url);
        });
      });
    },
    handleGetStateMember: function (data) {
      //展示关注公众号二位码+修改绑定微信二位码
      this.wxNick = data.wx_nick;
      getState(localStorage.getItem("token")).then((data) => {
        this.showBindConcernWx = true;
        this.showTimer = true;
        this.$nextTick(() => {
          document.getElementById("qrcodeConcern").innerHTML = "";
          this.changeWxToken = data.state;
          const qrcode = new QRCode("qrcodeConcern", {
            width: 180,
            height: 180,
            text: data.url, // 二维码地址
            colorDark: "#000",
            colorLight: "#fff",
          });
          qrcode.clear();
          qrcode.makeCode(data.url);
        });
      });
    },
  },
};
</script>

<style lang="scss">
#qrcode,
#qrcodeConcern {
  width: 180px;
  height: 180px;
  overflow: hidden;
  background: url("assets/placeholder.jpg") center no-repeat;
  background-size: cover;

  img {
    width: 100%;
    height: 100%;
    background-color: #fff; // 设置白色背景色
  }
}
.qc-line {
  position: relative;
  margin: 0 auto;
  width: 600px;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  font-size: 16px;
  margin-top: 50px;
  margin-bottom: 50px;
  color: rgba(101, 101, 101, 1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue